import { useEffect, useMemo, useState } from "react";
import moment from "moment-timezone";
import { useScrollContext } from "../context/useScrollContext";
import { useFilters } from "../../../../../utils/hooks/useFilters";

export const useCellWidth = (): number => {
    const { gridElement, headerElement } = useScrollContext();
    const [{ mode, from, to }] = useFilters();

    const minCellWidth = useMemo(() => {
        if (mode === "day") return 87;
        return 150;
    }, [mode]);

    const columnCount = useMemo(() => {
        if (mode === "day") return 24;
        if (mode === "week") return 7;
        const start = moment(from);
        const end = moment(to);
        if (!start.isValid() || !end.isValid()) return 7;
        return Math.max(end.diff(start, "days") + 1, 1);
    }, [mode, from, to]);

    const [cellWidth, setCellWidth] = useState<number>(minCellWidth);
    
    const container = gridElement ?? headerElement;

    useEffect(() => {
        if (!container) {
            setCellWidth(minCellWidth);
            return;
        }
        const measure = () => {
            const width = container.offsetWidth;
            if (!width) return;
            setCellWidth(Math.round(Math.max(width / columnCount, minCellWidth)));
        };

        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(container);
        return () => observer.disconnect();
    }, [container, columnCount, minCellWidth]);

    return cellWidth;
};
